module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('section', [_c('div', {
    staticClass: "buttons"
  }, [_c('b-button', [_vm._v("Button")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "tag": "a",
      "href": "https://buefy.org",
      "target": "_blank"
    }
  }, [_vm._v("\n                Anchor\n            ")]), _vm._v(" "), _c('b-button', {
    attrs: {
      "tag": "input",
      "native-type": "submit",
      "value": "Submit input"
    }
  })], 1)])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-0429a8f2"}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./docs/pages/components/button/examples/ExTags.vue
// module id = 976
// module chunks = 21 239